export enum AnalyseDepth {
    Standard = 'standard',
    DeepDetails = 'deep',
    DeepAbstract = 'abstract',
    BySpeaker = 'speaker'
}

export const AnalyseDepthLabelMap = {
    [AnalyseDepth.Standard]: 'Standard',
    [AnalyseDepth.DeepDetails]: 'Deep level of details',
    [AnalyseDepth.BySpeaker]: 'By speaker'
}


export const AnalyseDepthOptions = [
    {key: AnalyseDepth.Standard, label: AnalyseDepthLabelMap[AnalyseDepth.Standard]},
    {key: AnalyseDepth.DeepDetails, label: AnalyseDepthLabelMap[AnalyseDepth.DeepDetails]},
    {key: AnalyseDepth.BySpeaker, label: AnalyseDepthLabelMap[AnalyseDepth.BySpeaker]}
]

export const DefaultDepthOption = {key: AnalyseDepth.Standard, label: AnalyseDepthLabelMap[AnalyseDepth.Standard]};

export type AnalyseDepthOption = typeof AnalyseDepthOptions[number];
